import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { ApiErrorResponse } from 'types/apiTypes';
import { FormField } from 'types/formFieldTypes';

const apiUrl = process.env.REACT_APP_BACKEND_URL;

interface CustomFieldsState {
    customFields: FormField[];
    customFieldsLoading: boolean;
    error: string | null;
}

const initialState: CustomFieldsState = {
    customFields: [],
    customFieldsLoading: false,
    error: null,
}

export const fetchCustomFields = createAsyncThunk<
    FormField[],
    { orgId: number },
    { rejectValue: string }
>(
    'customFields/fetchCustomFields',
    async ({ orgId }, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${apiUrl}/orgs/${orgId}/formField`, {
                headers: {
                    Authorization: `${localStorage.getItem('authToken')}`,
                    Accept: 'application/json',
                },
            });

            const fields = (res.data.data || res.data) as FormField[];
            return fields.filter((field: FormField) => field.status === 1);

        } catch (error) {
            const axiosError = error as AxiosError<ApiErrorResponse>;
            return rejectWithValue(axiosError.response?.data?.message || 'Failed to fetch form fields');
        }
    }
)

const customFieldSlice = createSlice({
    name: 'customFields',
    initialState,
    reducers: {
        clearCustomFields(state) {
            state.customFields = [];
        },
        clearCustomFieldsError(state) {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomFields.pending, (state) => {
                state.customFieldsLoading = true;
                state.error = null;
            })
            .addCase(fetchCustomFields.fulfilled, (state, action) => {
                state.customFieldsLoading = false;
                state.customFields = action.payload;
            })
            .addCase(fetchCustomFields.rejected, (state, action) => {
                state.customFieldsLoading = false;
                state.error = action.payload || "Failed to fetch custom Fields";
            });

    },
});

export const { clearCustomFields, clearCustomFieldsError } = customFieldSlice.actions;
export default customFieldSlice.reducer;